module.exports = __webpack_public_path__ + "static/uiux-solitions-e01283ac920586a8586f740e7b59fe41.png";